import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AppSummarySearchBar from '@/common/components/form-inputs/AppSummarySearchBar';
import AppMultipleDropDownMenu from '@/common/components/form-inputs/AppMultipleDropDownMenu';
import { BOX_SERIES_TYPE, PUBLISHED_LISTB } from '@/common/constants/common';
import { WeekTreasureFilter } from '@/api/DTO/exchange/weekTreasure.interface';
import { QualityType } from '@/api/enum/common.enum';

export default function WeekTreasureSummaryFilterSection() {
	const { t } = useTranslation();
	const { control } = useFormContext<WeekTreasureFilter>();

	const qualityList = [
		{ id: QualityType.Normal, name: t('chartletList.normal') },
		{ id: QualityType.Rare, name: t('chartletList.rare') },
		{ id: QualityType.Precious, name: t('chartletList.precious') },
		{ id: QualityType.SuperPrecious, name: t('chartletList.superPrecious') },
	];

	return (
		<Grid container rowSpacing={2} columnSpacing={1}>
			<Grid item xs={3}>
				<AppSummarySearchBar
					name='searchString'
					control={control}
					placeholder={t('common.search')}
				/>
			</Grid>
			<Grid item xs={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='gameTypeList'
					label={t('box.treasureType')}
					options={BOX_SERIES_TYPE}
					size='small'
					emptyArrayIfNoSelection
				/>
			</Grid>
			<Grid item xs={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='publishedList'
					label={t('box.seriesStatus')}
					options={PUBLISHED_LISTB}
					size='small'
					emptyArrayIfNoSelection
				/>
			</Grid>
			<Grid item xs={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='qualityList'
					label={t('chartletList.quality')}
					options={qualityList}
					size='small'
					emptyArrayIfNoSelection
				/>
			</Grid>
		</Grid>
	);
}
